<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <div class="bg-white padding-lr" ref="container">

    </div>

    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" header="商家基本信息" class="goods-collapse">
          <a-row >
            <a-col :span="12">
              <a-form-model-item prop="merchantName" >
                <span slot="label" >
                  <a-tooltip>
                    商家名称<template slot="title">商家名称</template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.merchantName" :maxLength="255" :placeholder="$t('请输入')+'商家名称'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merchantApplyStatus" >
                <span slot="label" >
                  <a-tooltip>
                    申请状态<template slot="title">商家状态 待审核 </template>
                  </a-tooltip>
                </span>
                <a-select v-model="form.merchantApplyStatus" disabled :placeholder="$t('请输入')+'商家状态'" >
                  <a-select-option v-for="(item, index) in customDict.MerchantApplyStatusEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merchantLogo" >
                <span slot="label" >
                  <a-tooltip>
                    商家logo<template slot="title">商家logo</template>
                  </a-tooltip>
                </span>
                <oss-upload-single v-model="form.merchantLogo" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merchantBackground" >
                <span slot="label" >
                  <a-tooltip>
                    商家背景图<template slot="title">商家背景图</template>
                  </a-tooltip>
                </span>
                <oss-upload-single v-model="form.merchantBackground" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merchantAreax" >
                <span slot="label" >
                  <a-tooltip>
                    商家所在地<template slot="title">商家所在地</template>
                  </a-tooltip>
                </span>
                <a-cascader :options="areaList"
                            :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                            :placeholder="$t('请选择')+'商家所在地'"
                            style="width: 100%" v-model="areaSelected" allowClear @change="onAreaChange">
                </a-cascader>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merchantAddress" >
                <span slot="label" >
                  <a-tooltip>
                    详细地区<template slot="title">详细地区</template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.merchantAddress" :maxLength="255" :placeholder="$t('请输入')+'详细地区'" />
              </a-form-model-item>
            </a-col>

            <a-col :span="12">
              <a-form-model-item prop="customerServiceMobile" >
                <span slot="label" >
                  <a-tooltip>
                    客服电话<template slot="title">客服电话</template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.customerServiceMobile" :maxLength="32" :placeholder="$t('请输入')+'客服电话'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="marginAmount" >
                <span slot="label" >
                  <a-tooltip>
                    保证金<template slot="title">保证金</template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.marginAmount"  :placeholder="$t('请输入')+'保证金'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="timeOfEntry" >
                <span slot="label" >
                  <a-tooltip>
                    入驻时长<template slot="title">入驻时长</template>
                  </a-tooltip>
                </span>
                <a-select v-model="form.timeOfEntry" :placeholder="$t('请输入')+'入驻时长'" >
                  <a-select-option v-for="(item, index) in this.timeEntryList" :value="item.id" :key="index">
                    {{ item.duration }}年
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="businessType" >
                <span slot="label" >
                  <a-tooltip>
                    经营类型<template slot="title">经营类型</template>
                  </a-tooltip>
                </span>
                <a-select v-model="form.businessType" disabled :placeholder="$t('请输入')+'经营类型'" >
                  <a-select-option v-for="(item, index) in customDict.BusinessTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="merchantType" >
                <span slot="label" >
                  <a-tooltip>
                    商家类型<template slot="title">商家类型 企业 个人 事业单位</template>
                  </a-tooltip>
                </span>
                <a-select v-model="form.merchantType" :placeholder="$t('请输入')+'商家类型'" >
                  <a-select-option v-for="(item, index) in customDict.MerchantTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="industryId" >
                <span slot="label" >
                  <a-tooltip>
                    主营行业<template slot="title">主营行业</template>
                  </a-tooltip>
                </span>
                <a-select v-model="form.industryId" :placeholder="$t('请输入')+'主营行业'" >
                  <a-select-option v-for="(item, index) in industryList" :value="item.id" :key="index">
                    {{ item.categoryName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
<!--          <a-row>
            <a-col>
              <a-form-model-item prop="merchantDescription" >
                <span slot="label" >
                  <a-tooltip>
                    商家简介<template slot="title">商家简介</template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.merchantDescription" :placeholder="$t('请输入')" type="textarea" allow-clear />
              </a-form-model-item>
            </a-col>
          </a-row>-->
          <a-row>
            <a-col :span="24">
              <a-form-model-item :label-col="{span: 2}" :wrapper-col="{span: 20}"  label="商家简介" prop="description">
                <editor style="height: 300px" v-model="form.merchantDescription" :placeholder="$t('请输入')+'商家简介'"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>

          </a-row>
        </a-collapse-panel>
        <a-collapse-panel header="公司信息" key="2" v-if="form.merchantType===1" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="companyName" >
                <span slot="label" >
                  <a-tooltip>
                    公司名称
                     <template slot="title">
                        <p>请填写登记证书上的商户名称</p>
                        <p>前后不能有空格、制表符、换行符</p>
                        <p>不能仅含数字、特殊字符</p>
                        <p>仅能填写数字、英文字母、汉字及特殊字符</p>
                        <p>个体户证件为以下情况时，按照个体户XXX命名（XXX是营业执照经营人姓名）：营业执照登记名称为空、仅含数字、仅含特殊字符、“无”、“无字号”</p>
                        <p>个体户不能使用“企业”“公司”或“农民专业合作社”结尾</p>
                        <p>示例值：腾讯科技有限公司</p>
                      </template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.companyName" :maxLength="50" :placeholder="$t('请输入')+'公司名称'" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="companyAreax" >
                <span slot="label" >
                  <a-tooltip>
                    公司所在地<template slot="title">公司所在地</template>
                  </a-tooltip>
                </span>
                <a-cascader :options="areaList"
                            :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                            :placeholder="$t('请选择')+'公司所在地'"
                            style="width: 100%" v-model="companyAreaSelected" allowClear @change="onCompanyAreaChange">
                </a-cascader>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="companyAddress" >
                <span slot="label" >
                  <a-tooltip>
                    公司详细地址<template slot="title">公司详细地址</template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.companyAddress" :maxLength="50" :placeholder="$t('请输入')+'公司详细地址'" />
             </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="businessLicenceNo" >
                <span slot="label" >
                  <a-tooltip>
                    营业执照号
                     <template slot="title">
                        <p>主体为“个体工商户”时，请填写营业执照上的注册号/统一社会信用代码，格式需满足以下任一条件：-15位数字-18位阿拉伯数字或大写英文字母（不得包含英文字母I/O/Z/S/V），并且以9开头</p>
                        <p>主体为“企业”时，请填写营业执照上的注册号/统一社会信用代码，格式如下：-18位阿拉伯数字或大写英文字母（不得包含英文字母I/O/Z/S/V），并且以9开头</p>
                      </template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.businessLicenceNo" :maxLength="50" :placeholder="$t('请输入')+'营业执照号'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="businessLicenseImg" >
                <span slot="label" >
                  <a-tooltip>
                    营业执照照片<template slot="title">营业执照照片</template>
                  </a-tooltip>
                </span>
                <oss-upload-single v-model="form.businessLicenseImg" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactName" >
                <span slot="label" >
                  <a-tooltip>
                    法人名称<template slot="title"></template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.contactName" :maxLength="50" :placeholder="$t('请输入')+'法人名称'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactPhone" >
                <span slot="label" >
                  <a-tooltip>
                    法人手机号<template slot="title"></template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.contactPhone" :maxLength="20" :placeholder="$t('请输入')+'法人手机号'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactCardNo" >
                <span slot="label" >
                  <a-tooltip>
                    法人身份证号<template slot="title">法人身份证号</template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.contactCardNo" :maxLength="20" :placeholder="$t('请输入')+'法人身份证号'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactEmail" >
                <span slot="label" >
                  <a-tooltip>
                    联系人邮箱<template slot="title"></template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.contactEmail" :maxLength="50" :placeholder="$t('请输入')+'联系人邮箱'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactCardNational" >
                <span slot="label" >
                  <a-tooltip>
                    身份证国徽面<template slot="title">身份证正面,国徽面</template>
                  </a-tooltip>
                </span>
                <oss-upload-single style="width:100px;height: 70px " v-model="form.contactCardNational" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactCardFace" >
                <span slot="label" >
                  <a-tooltip>
                    身份证人像面<template slot="title">身份证反面,人像面</template>
                  </a-tooltip>
                </span>
                <oss-upload-single style="width:100px;height: 70px " v-model="form.contactCardFace" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
          </a-row>


        </a-collapse-panel>
        <a-collapse-panel header="个人信息" key="3" v-if="form.merchantType===2" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="contactName" >
                <span slot="label" >
                  <a-tooltip>
                    联系人名称<template slot="title"></template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.contactName" :maxLength="50" :placeholder="$t('请输入')+'联系人名称'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactPhone" >
                <span slot="label" >
                  <a-tooltip>
                    手机号<template slot="title"></template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.contactPhone" :maxLength="20" :placeholder="$t('请输入')+'手机号'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactCardNo" >
                <span slot="label" >
                  <a-tooltip>
                    身份证号<template slot="title">身份证号</template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.contactCardNo" :maxLength="20" :placeholder="$t('请输入')+'身份证号'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactEmail" >
                <span slot="label" >
                  <a-tooltip>
                    联系人邮箱<template slot="title"></template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.contactEmail" :maxLength="50" :placeholder="$t('请输入')+'联系人邮箱'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactCardNational" >
                <span slot="label" >
                  <a-tooltip>
                    身份证国徽面<template slot="title">身份证正面,国徽面</template>
                  </a-tooltip>
                </span>
                <oss-upload-single style="width:100px;height: 70px " v-model="form.contactCardNational" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="contactCardFace" >
                <span slot="label" >
                  <a-tooltip>
                    身份证人像面<template slot="title">身份证反面,人像面</template>
                  </a-tooltip>
                </span>
                <oss-upload-single style="width:100px;height: 70px " v-model="form.contactCardFace" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>

        <a-collapse-panel header="结算账户" key="4" class="goods-collapse">
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="accountType">
                <span slot="label" >
                  <a-tooltip>
                    账户类型
                    <template slot="title">支付包,微信,银行卡</template>
                  </a-tooltip>
                </span>
                <a-radio-group  v-model="form.accountType"  button-style="solid" >
                  <a-radio-button v-for="(item, index) in customDict.MerchantAccountTypeEnum" :value="item.type" :key="index">
                    {{ item.name }}
                  </a-radio-button>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="12" >
              <a-form-model-item prop="accountNo" >
                  <span slot="label" >
                    <a-tooltip>
                      结算账号
                      <template slot="title">结算账号</template>
                    </a-tooltip>
                  </span>
                <a-input v-model="form.accountNo" :maxLength="32" :placeholder="$t('请输入')+'结算账号'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" >
              <a-form-model-item prop="accountName" >
                  <span slot="label" >
                    <a-tooltip>
                      结算账户名
                      <template slot="title">
                        <p> 选择经营者个人银行卡时，开户名称必须与身份证姓名一致</p>
                        <p> 选择对公账户时，开户名称必须与营业执照上的“商户名称”一致</p>
                      </template>
                    </a-tooltip>
                  </span>
                <a-input v-model="form.accountName" :maxLength="32" :placeholder="$t('请输入')+'结算账户名'" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="accountBankName"  v-if="form.accountType===3">
                  <span slot="label" >
                    <a-tooltip>
                      开户银行名称
                      <template slot="title">
                        开户银行,输入并搜索
                      </template>
                    </a-tooltip>
                  </span>
                <a-select
                  allowClear
                  :default-active-first-option="false" v-model="form.accountBankName"
                  :filter-option="false" :show-arrow="false" :not-found-content="null"
                  show-search
                  @search="handleBankSearch"
                  @change="handleBankChange">
                  <a-select-option v-for="(item, index) in bankList" :value="item.bankAlias" :key="index.bankAlias">
                    {{ item.bankAlias }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="accountBankBranchCode"   v-if="form.accountType===3">
                  <span slot="label" >
                    <a-tooltip>
                      开户支行
                      <template slot="title">
                         {{$t('商家账户.开户支行')}}
                      </template>
                    </a-tooltip>
                  </span>
                <a-button  @click="openBranchSelect" style="text-align: left; width: 100%" >
                  {{this.getBranchName()}}
                </a-button>
              </a-form-model-item>
            </a-col>
              <a-col :span="12">
                <a-form-model-item prop="accountBankAreaId"   v-if="form.accountType===3">
                  <span slot="label" >
                    <a-tooltip>
                      开户银行地址
                      <template slot="title">
                         开户银行地址精确到市
                      </template>
                    </a-tooltip>
                  </span>
                  <a-cascader :options="cityList"
                              :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                              :placeholder="$t('请选择')+$t('商家账户.开户银行地址')"
                              style="width: 100%" v-model="citySelected" allowClear @change="onCityChange">
                  </a-cascader>
                </a-form-model-item>
              </a-col>
            <a-col :span="12">
              <a-form-model-item prop="accountImg" v-if="form.accountType!==3">
                <span slot="label" >
                  <a-tooltip>
                    结算账户图片<template slot="title">结算账户图片</template>
                  </a-tooltip>
                </span>
                <oss-upload-single v-model="form.accountImg" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item prop="remark" >
                <span slot="label" >
                  <a-tooltip>
                    打款凭证<template slot="title">打款凭证<</template>
                  </a-tooltip>
                </span>
                <oss-upload-single v-model="form.paymentImg" :disabled="true" prefix="merchant" type="img"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item prop="remark" >
                <span slot="label" >
                  <a-tooltip>
                    打款备注<template slot="title">打款备注</template>
                  </a-tooltip>
                </span>
                <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-collapse-panel>
      </a-collapse>


      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" v-hasPermi="['merchant:merchantapply:audit']" v-if="form.merchantApplyStatus === 11 || form.merchantApplyStatus === 13" @click="$refs.auditForm.handleAudit(form.id, 'merchant')">
            审核
          </a-button>
          <a-button type="primary" :loading="submitLoading" v-hasPermi="['merchant:merchantapply:marginaudit']"  v-if="form.merchantApplyStatus === 21 || form.merchantApplyStatus === 23" @click="$refs.auditForm.handleAudit(form.id, 'margin')">
            保证金审核
          </a-button>
          <a-button type="primary" :loading="submitLoading" v-hasPermi="['merchant:merchantapply:edit']" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <radio-branch-select-form ref="RadioBranchSelectForm" @branchSelect="indexBranchSelect"></radio-branch-select-form>
    <audit-form
      ref="auditForm"
      @ok="handleUpdate(undefined, form.id)"
    />
  </a-drawer>
</template>

<script>
import { getMerchantApply, addMerchantApply, updateMerchantApply } from '@/api/merchant/merchantApply'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import {areaListTree,cityListTree} from '@/api/logistics';
import {listEntry} from "@/api/merchant/entry";
import editor from "@/components/Editor";
import {listBank} from "@/api/merchant/bank";
import RadioBranchSelectForm from '@/views/merchant/branch/modules/RadioSelectForm'
import AuditForm from './AuditForm.vue'
import {listIndustry} from "@/api/merchant/industry";


let bankTimeout;
let currentBankValue;
function getBankList(value, callback) {
  if (bankTimeout) {
    clearTimeout(bankTimeout);
    bankTimeout = null;
  }
  currentBankValue = value;
  function fake() {
    listBank({"bankAlias": value}).then(response => {
      if (currentBankValue === value) {
        this.bankList = response.data
        callback(response.data);
      }
    })
  }
  bankTimeout = setTimeout(fake, 300);
}

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
    CustomDictTag,
    RadioBranchSelectForm,
    AuditForm,
    editor
  },
  data () {
    return {
      timeEntryList: [],
      areaList: [],
      areaSelected: [],
      cityList:[],
      citySelected:[],
      companyAreaSelected: [],
      bankList:[],
      branchResult: {},
      industryList: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      activeKey: [1, 2, 3, 4, 5],
      loading: '',
      // 表单参数
      form: {
        id: null,
        merchantId: null,
        merchantName: null,
        merchantLogo: null,
        merchantBackground: null,
        merchantAreax: null,
        merchantAreac:null,
        merchantAreap:null,
        merchantAddress: null,
        merchantApplyStatus: 0,
        merchantDescription: null,
        merchantType: null,
        longitude: null,
        latitude: null,
        marginAmount: null,
        industryId: null,
        timeOfEntry: null,
        customerServiceMobile: null,
        businessType: null,
        companyAreax: null,
        companyName: null,
        companyAddress: null,
        businessLicenceNo: null,
        businessLicenseImg: null,
        contactName: null,
        contactPhone: null,
        contactEmail: null,
        contactCardNo: null,
        contactCardImg: null,
        contactCardNational: null,
        contactCardFace: null,
        accountType: null,
        accountBankName: null,
        accountBankAreaId: null,
        accountBankBranchCode: null,
        accountImg: null,
        accountNo: null,
        accountName: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        merchantName: [
          { required: true, message: '商家名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantLogo: [
          { required: true, message: '商家logo'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantBackground: [
          { required: true, message: '商家背景图'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantAddress: [
          { required: true, message: '详细地区'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantApplyStatus: [
          { required: true, message: '商家状态'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantType: [
          { required: true, message: '商家类型'+this.$t('不能为空'), trigger: 'change' }
        ],
        merchantAreax: [
          { required: true, message: '商家所在地 '+this.$t('不能为空'), trigger: 'change' }
        ],
        industryId: [
          { required: true, message: '主营行业id'+this.$t('不能为空'), trigger: 'blur' }
        ],
        marginAmount: [
          { required: true, message: '保证金'+this.$t('不能为空'), trigger: 'blur' }
        ],
        timeOfEntry: [
          { required: true, message: '入驻时长'+this.$t('不能为空'), trigger: 'change' }
        ],
        customerServiceMobile: [
          { required: true, message: '客服电话'+this.$t('不能为空'), trigger: 'blur' }
        ],
        businessType: [
          { required: true, message: '经营类型'+this.$t('不能为空'), trigger: 'change' }
        ],
        companyAreax: [
          { required: true, message: '公司所在地'+this.$t('不能为空'), trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '公司名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        businessLicenceNo: [
          { required: true, message: '营业执照号'+this.$t('不能为空'), trigger: 'blur' }
        ],
        businessLicenceImg: [
          { required: true, message: '营业执照照片'+this.$t('不能为空'), trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: '联系人姓名'+this.$t('不能为空'), trigger: 'blur' }
        ],
        contactPhone: [
          { required: true, message: '联系人手机号'+this.$t('不能为空'), trigger: 'blur' }
        ],
        contactEmail: [
          { required: false, message: '联系人邮箱'+this.$t('不能为空'), trigger: 'blur' }
        ],
        contactCardNo: [
          { required: true, message: '身份证号'+this.$t('不能为空'), trigger: 'blur' }
        ],
        contactCardNational: [
          { required: true, message: '身份证正面国徽面'+this.$t('不能为空'), trigger: 'blur' }
        ],
        contactCardFace: [
          { required: true, message: '身份证反面人像面'+this.$t('不能为空'), trigger: 'blur' }
        ],
        accountType: [
          { required: true, message: '账户类型'+this.$t('不能为空'), trigger: 'change' }
        ],
        accountBankName: [
          { required: true, message: '开户银行名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        accountBankAreaId: [
          { required: true, message: '开户银行地址'+this.$t('不能为空'), trigger: 'blur' }
        ],
        accountBankBranchCode: [
          { required: true, message: '开户支行行联号'+this.$t('不能为空'), trigger: 'blur' }
        ],
        accountNo: [
          { required: true, message: '结算账户'+this.$t('不能为空'), trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '结算账户名(真实姓名)'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getAreaTree()
    this.getCityTree()
    this.getTimeEntry()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getAreaTree() {
      areaListTree().then(response => {
        this.areaList = response.data
      })
    },
    onAreaChange(value, selectedOptions) {
      this.form.merchantAreax = value[2]
      console.log('onAreaChange',this.form.merchantAreax)
    },
    getCityTree() {
      cityListTree().then(response => {
        this.cityList = response.data
      })
    },
    onCityChange() {
      this.form.accountBankAreaId=this.citySelected[1]
    },
    onCompanyAreaChange(value, selectedOptions) {
      this.form.companyAreax = value[2]
    },
    getTimeEntry() {
      listEntry({}).then(response => {
        this.timeEntryList = response.data
      })
    },
    getIndustryList(merchantType) {
      listIndustry({merchantType:merchantType}).then(response => {
        this.industryList = response.data
      })
    },
    openBranchSelect () {
      this.$refs.RadioBranchSelectForm.openBranch(this.form.accountBankName, this.form.accountBankBranchCode, this.form.accountBankAreaId);
    },
    indexBranchSelect(record) {
      this.branchResult = record;
      this.form.accountBankBranchCode = record.code;
      //自动选择地址
      this.form.accountBankAreaId=record.cityCode
      this.citySelected.push(record.cityCode.substring(0,2)+'0000')
      this.citySelected.push(record.cityCode)
    },
    getBranchName() {
      if (this.form.accountBankBranchCode) {
        return this.branchResult.name
      } else {
        return this.$t('请选择')+this.$t('商家账户.开户支行')
      }
    },
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        merchantId: null,
        merchantName: null,
        merchantLogo: null,
        merchantBackground: null,
        merchantAreax: null,
        merchantAreac:null,
        merchantAreap:null,
        merchantAddress: null,
        merchantApplyStatus: 0,
        merchantDescription: null,
        merchantType: null,
        longitude: null,
        latitude: null,
        marginAmount: null,
        industryId: null,
        timeOfEntry: null,
        customerServiceMobile: null,
        businessType: null,
        companyAreax: null,
        companyName: null,
        companyAddress: null,
        businessLicenceNo: null,
        businessLicenseImg: null,
        contactName: null,
        contactPhone: null,
        contactEmail: null,
        contactCardNo: null,
        contactCardImg: null,
        contactCardNational: null,
        contactCardFace: null,
        accountType: null,
        accountBankName: null,
        accountBankAreaId: null,
        accountBankBranchCode: null,
        accountImg: null,
        accountNo: null,
        accountName: null,
        imgDetail: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }
      this.companyAreaSelected=[]
      this.areaSelected=[]
      this.citySelected = []

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMerchantApply({"id":id}).then(response => {
        this.form = response.data
        this.areaSelected.push(this.form.merchantAreap);
        this.areaSelected.push(this.form.merchantAreac);
        this.areaSelected.push(this.form.merchantAreax);
        this.companyAreaSelected.push(this.form.companyAreax.substring(0, 2) + '0000');
        this.companyAreaSelected.push(this.form.companyAreax.substring(0, 4) + '00');
        this.companyAreaSelected.push(this.form.companyAreax);
        if (this.form.accountBankAreaId) {
          this.citySelected.push(this.form.accountBankAreaId.substring(0, 2) + '0000');
          this.citySelected.push(this.form.accountBankAreaId);
        }
        this.branchResult = response.data.branchResult;
        this.bankList.push({
          "bankName": this.form.accountBankName
        });
        this.open = true
        this.formTitle = this.$t('修改')
        this.getIndustryList(this.form.merchantType)
      })
    },
    //银行选择
    handleBankSearch(value) {
      getBankList(value,data=>(this.bankList=data))
    },
    handleBankChange(value) {
      console.log('搜索选中了银行信息:',value)
      this.form.accountBankName = value;
      //getBankList(value, data => (this.bankList = data));
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateMerchantApply(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addMerchantApply(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" >
.goods-collapse > .ant-collapse-header {
  color: #0e75d3 !important;
  background: #e8eef9;
}
.ant-form-item-label {
  word-wrap: break-word; /* 或使用 overflow-wrap: break-word; */
  white-space: pre-line; /* 确保空格和其他空白字符按预期显示 */
}
.cardUpload {
  width: 150px;
  height: 100px;
  margin-right: 0;
  margin-bottom: 0;
}
.cardUpload>.ant-upload.ant-upload-select-picture-card {
  width: 100%;
  height: 100%;
  margin-right: 0;
  margin-bottom: 0;
}

.cardUploadList {
  width: 150px;
  height: 100px;
  margin-right: 0;
  margin-bottom: 0;
}
.cardUploadList>.ant-upload-list-picture-card>.ant-upload-list-picture-card-container {
  width: 100%;
  height: 100%;
}
.cardUploadList>.ant-upload-list-picture-card>.ant-upload-list-picture-card-container>span>.ant-upload-list-item-list-type-picture-card {
  width: 100%;
  height: 100%;
  margin-right: 0;
  margin-bottom: 0;
}
.info-table {
  width: 100%;
  tr {
    height: 50px;
  }
  td {
    display: table-cell;
    vertical-align: top;
    font-size: 16px;
  }

  .first {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    word-wrap: break-word;
    text-align: left;
    width: 10%;
  }

  .data {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    word-wrap: break-word;
    text-align: left;
    width: 40%;
  }
}


</style>
